import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgMoney(props: ISvgProps) {
	return (
		<svg width={60} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M53.286 33.039c1.298-1.299-.675-3.272-1.974-1.974h.003l-5.187 5.187c-1.3 1.298.673 3.272 1.971 1.973l5.187-5.186ZM6.718 20.647c-1.298 1.299.675 3.272 1.973 1.974H8.69l5.187-5.187c1.3-1.298-.673-3.272-1.971-1.973l-5.187 5.186Z"
				fill={props.secondaryColor}
			/>
			<path
				d="M56.33 42.882h-.856l-2.486 9.284a1.394 1.394 0 0 1-1.707.987l-38.325-10.27H3.673a1.395 1.395 0 0 1-1.395-1.395V12.196c0-.771.624-1.394 1.395-1.394h52.66c.77 0 1.394.623 1.394 1.394v29.292c0 .771-.624 1.395-1.395 1.395h-.002Zm-3.738 0h-28.87l26.936 7.216 1.934-7.216ZM5.068 40.096h49.868V13.593H5.068v26.503Z"
				fill={props.primaryColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M32.335 22.87c0-.364-.478-.765-1.166-.765h-2.333c-.688 0-1.166.401-1.166.765v1.906c0 .364.478.764 1.166.764h2.333c1.93 0 3.498 1.372 3.498 3.055V30.5c0 1.683-1.568 3.054-3.498 3.054v1.727l-.003.003a1.165 1.165 0 0 1-2.325.027l-.005-.001v-1.756c-1.93 0-3.498-1.37-3.498-3.054 0-.633.522-1.145 1.166-1.145.644 0 1.166.512 1.166 1.145 0 .363.478.764 1.166.764h2.333c.688 0 1.166-.4 1.166-.761v-1.91c0-.363-.478-.764-1.166-.764h-2.333c-1.93 0-3.498-1.37-3.498-3.051v-1.91c0-1.682 1.568-3.053 3.498-3.053v-1.718c0-.633.522-1.145 1.167-1.145.644 0 1.166.512 1.166 1.145v1.718c1.93 0 3.498 1.37 3.498 3.054 0 .632-.522 1.145-1.166 1.145a1.155 1.155 0 0 1-1.166-1.145Z"
				fill={props.secondaryColor}
			/>
		</svg>
	);
}

export default SvgMoney;
